module.exports = __webpack_public_path__ + "static/media/01B.f72e7627.png";